import script from "./PreSportsCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsCoupons.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsCoupons.vue?vue&type=style&index=0&id=2e769bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e769bb0"]])

export default __exports__